import React, {useEffect} from "react"
import AOS from "aos";
import '../styles/components/PostComponent.css'

const PostComponent = () => {

    useEffect(()=> {
        AOS.init({duration: 2000});
    }, []);

    return (
        <>
            <div className='post'>
                <h1>المـدونـة</h1>
                <div className='paragraph'>
                    <h2>انظر إلى عملك من منظور مختلف وجديد..</h2>
                    <div className='postImage'></div>
                    <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور
                        أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد
                        أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات . ديواس
                        أيوتي أريري دولار إن ريبريهينديرأيت فوليوبتاتي فيلايت أيسسي كايلليوم دولار أيو فيجايت
                        نيولا باراياتيور. أيكسسيبتيور ساينت أوككايكات كيوبايداتات نون بروايدينت ,سيونت ان كيولبا
                        كيو أوفيسيا ديسيريونتموليت انيم أيدي ايست لابوريوم</p>
                </div>
                <div className='quote'>
                    <h2>كما يقول المؤلف الشهير ...</h2>
                    <blockquote>
                        لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت
                        أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد
                        <br/><br/>_ أحمد مبارك
                    </blockquote>
                </div>
                <div className='conclusion'>
                    <h2>الخاتمــة </h2>
                    <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور
                        أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد
                        أكسير سيتاشن يللأمكو لابورأس نيسي يت أليكيوب أكس أيا كوممودو
                    </p>
                </div>
                <div className='comment'>
                    <h2>اتـــرك  تعليـــــق..</h2>
                    <form>
                        <div className='inputs' data-aos='fade-left'>
                            <div className='name'>
                                <p>الاسم</p>
                                <input type='name'/>
                            </div>
                            <div className='email'>
                                <p>الإيميل</p>
                                <input type='email'/>
                            </div>
                            <div className='message'>
                                <p>الرسالة</p>
                                <input type='text'/>
                            </div>
                        </div>
                        <div className='submit-div'>
                            <a className='submit'>أرســـل</a>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default PostComponent;